import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { unwrapPagedResponseModel, unwrapResponseModel } from '../api/responseModel';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

function createPagedList(indexPath, defaultPageSize = 10) {
  return (query = { page: 1, pageSize: defaultPageSize }) => {
    const qs = buildPagedQuery(query);
    return apiClient.get(`${indexPath}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
  };
}

function createPeriodoResource(indexPath, basePath) {
  const listPaged = createPagedList(indexPath);
  return {
    resetForTests() {
      // Sin caché deduplicada tras F4-011.
    },
    list(query) {
      return listPaged(query);
    },
    lookup(query) {
      return listPaged({ pageSize: 5, ...query });
    },
    get(id) {
      return requestAndUnwrap(apiClient.get(`${basePath}/${id}`));
    },
    delete(id) {
      return requestAndUnwrap(apiClient.get(`${basePath}/delete/${id}`));
    },
    save(payload) {
      return requestAndUnwrap(apiClient.post(basePath, payload));
    }
  };
}

const periodoCursada = createPeriodoResource('/api/pcr/Index', '/api/pcr');
const periodoExamen = createPeriodoResource('/api/pex/Index', '/api/pex');

export function resetPeriodoCursadaListCacheForTests() {
  periodoCursada.resetForTests();
}

export function resetPeriodoExamenListCacheForTests() {
  periodoExamen.resetForTests();
}

export function listPeriodoCursada(query) {
  return periodoCursada.list(query);
}

export function lookupPeriodoCursada(query) {
  return periodoCursada.lookup(query);
}

export function getPeriodoCursada(id) {
  return periodoCursada.get(id);
}

export function deletePeriodoCursada(id) {
  return periodoCursada.delete(id);
}

export function savePeriodoCursada(payload) {
  return periodoCursada.save(payload);
}

export function listPeriodoExamen(query) {
  return periodoExamen.list(query);
}

export function lookupPeriodoExamen(query) {
  return periodoExamen.lookup(query);
}

export function getPeriodoExamen(id) {
  return periodoExamen.get(id);
}

export function deletePeriodoExamen(id) {
  return periodoExamen.delete(id);
}

export function savePeriodoExamen(payload) {
  return periodoExamen.save(payload);
}
